type Props = {
    search: string;
    onSearchChange: (value: string) => void;
    filter: string;
    onFilterChange: (value: string) => void;
}

export const MessagesListHeader = ({ search, onSearchChange, filter, onFilterChange }: Props) => {

    return (
        <div className="messages-page-list-header">
            <h5>Messages</h5>

            <select value={filter} onChange={(e) => onFilterChange(e.target.value)}>
                <option value="all">All Messages</option>
                <option value="introduction">Introductions</option>
                <option value="experience">Experiences</option>
                <option value="forum">Mastermind Circles</option>
            </select>

            <div className="search-group">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <g clip-path="url(#clip0_7511_59848)">
                        <path d="M7.1875 13.125C10.4667 13.125 13.125 10.4667 13.125 7.1875C13.125 3.90831 10.4667 1.25 7.1875 1.25C3.90831 1.25 1.25 3.90831 1.25 7.1875C1.25 10.4667 3.90831 13.125 7.1875 13.125Z" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.75 13.75L12.5 12.5" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_7511_59848">
                        <rect width="15" height="15" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                <input 
                    type="text" 
                    placeholder="Search" 
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>
        </div>
    )
}